
<div class="eod-input">
  <label for="example-text-input" class="form-label">{{ field.templateOptions.placeholder }}@if (field.templateOptions.required){<span class="required-field">*</span>}</label>
  <ng-select id="{{ 'select' + fieldKey }}" class="select-dropdown select-dropdown--md multiSelectCategoryDropdown"
    [items]="to.options" bindLabel="value" bindValue="id" [clearable]="false" appendTo="body"
    placeholder="{{ field.templateOptions.placeholder }}"
     [formControl]="formControl" [selectOnTab]="true"
    notFoundText="{{ 'no_data_available' | translate: param }}" (change)="onValueChange()" [multiple]="true"
    groupBy="groupByField" [selectableGroup]="true" [selectableGroupAsModel]="false" [closeOnSelect]="false"
    [selectOnTab]="true" (open)="onOpen()">
    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
      @if(items.length != to.options.length){<div>
        <div class="ng-value" *ngFor="let item of items | slice: 0:1">
          {{ item.value }}
        </div>
      </div>}
      @if(items.length == to.options.length){<div class="ng-value">
        {{ 'all' | translate}}
      </div>}
      @if(items.length != to.options.length && items.length > 1){<div class="ng-value">
        <span class="ng-value-label">(+{{ items.length - 1 }})</span>
      </div>}
    </ng-template>
    <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
      <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" />
      {{ 'all' | translate}}
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
      <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" />
      {{ item.value }}
    </ng-template>
  </ng-select>

  @if(formControl.errors && formControl.errors.required && isFormSubmitted){<div class="alert-danger">
    <small class="helper-text">{{ "label_Required" | translate: param }}</small>
  </div>}

  @if(field.templateOptions.customErrors && isFormSubmitted){<span>
    @for(error of field.templateOptions.customErrors; track error; let i = $index){<div class="alert-danger">
        
      
    </div>}
  </span>}

  @if(field.templateOptions.alertNote){<div class="alert-danger">
    <small class="helper-text">{{ field.templateOptions.alertNote }}</small>
  </div>}

</div>